import { createSlice } from '@reduxjs/toolkit';

import {
  BDRequestStatus,
  BDRequestType,
} from '~/common/models/apis/apiResponse.model';

import { CAMERAS_SETTINGS_EXTRA_REDUCER_BUILDERS } from './camerasSettings.reducers';
import { CAMERAS_SETTINGS_ACTIONS } from './camerasSettingsSlice.action';
import type { CamerasSettingsState } from './camerasSettingsSlice.model';

const initialState: CamerasSettingsState = {
  settings: [],
  operations: {
    [BDRequestType.GET_ALL]: {
      status: BDRequestStatus.IDLE,
      errors: [],
    },
    [BDRequestType.UPDATE]: {
      status: BDRequestStatus.IDLE,
      errors: [],
    },
  },
};

export const camerasSettingsSlice = createSlice({
  name: 'camerasSettings',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    CAMERAS_SETTINGS_EXTRA_REDUCER_BUILDERS.buildFetchCamerasSettingsReducer(
      builder
    );
    CAMERAS_SETTINGS_EXTRA_REDUCER_BUILDERS.buildUpdateCamerasSettingsReducer(
      builder
    );
  },
});

export const { fetchCamerasSettings, updateCamerasSettings } =
  CAMERAS_SETTINGS_ACTIONS;
export const camerasSettingsReducer = camerasSettingsSlice.reducer;

export * from './camerasSettingsSlice.selectors';
